module.exports = require("./../../_gen/starling/assets/AssetManager");


//////////////////
// WEBPACK FOOTER
// ./lib/starling/assets/AssetManager.js
// module id = 135
// module chunks = 0